import { useEffect } from 'react';
import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EcoImg from 'eco-design/base/eco-img';

export default function Solution() {
    const { useLang } = useGlobal();
    const { t } = useLang('PoweroceanPlus.Solution');
    let innerHeight = 1080;

    if (typeof window !== 'undefined') {
        innerHeight = window?.innerHeight;
    }

    useEffect(() => {
        const AniContainer = window?.AniContainer;
        const scrollHeight = 150;
        AniContainer.create({
            asyncFromTo: [
                ['.part11 .card-1 .text-box', { opacity: 1, y: 0 }, { opacity: 0, y: -scrollHeight }, 0.6], //1
                ['.part11 .card-1 .img-box', { opacity: 1 }, { opacity: 0 }, 0.0001],
                ['.part11 .card-2 .img-box', { opacity: 0 }, { opacity: 1 }, 0.0001],
                ['.part11 .card-2 .text-box', { opacity: 0, y: scrollHeight }, { opacity: 1, y: 0 }, 0.6], // 4
                ['.part11 .card-2 .text-box', { opacity: 1, y: 0 }, { opacity: 0, y: -scrollHeight }, 0.6], // 5
                ['.part11 .card-2 .img-box', { opacity: 1 }, { opacity: 0 }, 0.0001],
                ['.part11 .card-3 .img-box', { opacity: 0 }, { opacity: 1 }, 0.0001],
                ['.part11 .card-3 .text-box', { opacity: 0, y: scrollHeight }, { opacity: 1, y: 0 }, 0.6], // 8
                ['.part11 .card-3 .text-box', { opacity: 1, y: 0 }, { opacity: 0, y: -scrollHeight }, 0.6], // 9
                ['.part11 .card-3 .img-box', { opacity: 1 }, { opacity: 0 }, 0.0001],
                ['.part11 .card-4 .img-box', { opacity: 0 }, { opacity: 1 }, 0.0001],
                ['.part11 .card-4 .text-box', { opacity: 0, y: scrollHeight }, { opacity: 1, y: 0 }, 0.6], // 12
            ],
            aysnvTimeLine: [0.6, 0.6, 0.6, 0.6, 1.5, 2, 2, 2, 3, 3, 3, 3.4],

            triggerElement: '.part11',
            triggerHook: 1,
            offset: '100%',
            duration: '400%',
            scrollUpdatePos: true,
        });
    }, []);

    return (
        <div className={`${styles.solution} part11`}>
            <div className="content-box" style={{ height: innerHeight * 6 }}>
                <div className="sticky">
                    <div className="card-wrapper">
                        <div className="card-box">
                            <div className="card-outer-box">
                                <div className="card card-1">
                                    <div className="container">
                                        <div className="text-box">
                                            <h2>
                                                <span className="sub-title">{t('label1')}&nbsp;</span>
                                                <span className="title">{t('title1')}</span>
                                            </h2>
                                            <div className="sub-desc">{t('desc1')}</div>
                                        </div>
                                    </div>
                                    <div className="img-box">
                                        <EcoImg pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713766796055/1tuya.jpg" alt={t('title1')} />
                                    </div>
                                </div>
                            </div>
                            <div className="card-outer-box">
                                <div className="card card-2">
                                    <div className="container">
                                        <div className="text-box">
                                            <h2>
                                                <span className="sub-title">{t('label2')}&nbsp;</span>
                                                <span className="title">{t('title2')}</span>
                                            </h2>
                                            <div className="sub-desc">{t('desc2')}</div>
                                        </div>
                                    </div>
                                    <div className="img-box">
                                        <EcoImg pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713766816709/3tuya.jpg" alt={t('title2')} />
                                    </div>
                                </div>
                            </div>
                            <div className="card-outer-box">
                                <div className="card card-3">
                                    <div className="container">
                                        <div className="text-box">
                                            <h2>
                                                <span className="sub-title">{t('label3')}&nbsp;</span>
                                                <span className="title">{t('title3')}</span>
                                            </h2>
                                            <div className="sub-desc">{t('desc3')}</div>
                                        </div>
                                    </div>
                                    <div className="img-box">
                                        <EcoImg pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713766800726/2tuya.jpg" alt={t('title3')} />
                                    </div>
                                </div>
                            </div>
                            <div className="card-outer-box">
                                <div className="card card-4">
                                    <div className="container">
                                        <div className="text-box">
                                            <h2>
                                                <span className="sub-title">{t('label4')}&nbsp;</span>
                                                <span className="title">{t('title4')}</span>
                                            </h2>
                                            <div className="sub-desc">{t('desc4')}</div>
                                        </div>
                                    </div>
                                    <div className="img-box">
                                        <EcoImg pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713766820964/4tuya.jpg" alt={t('title4')} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export const getStaticProps = async () => {
    return {
        props: {},
    };
};
